import { ListItemText as MuiListItemText } from '@mui/material';

export default MuiListItemText;
